import { getPlazaPluginClientBySearchType } from './plazaMultiSourceSearch.js';

const PLUGIN_SEARCH_TYPES = [
  'qq-plugin',
  'wy-plugin',
  'kw-plugin',
  'kg-plugin',
  'mg-plugin',
  'lx-qq-plugin',
  'lx-kw-plugin',
  'lx-kg-plugin',
  'lx-wy-plugin'
];

export function isExternalPluginSource(source) {
  return PLUGIN_SEARCH_TYPES.includes(source);
}

/** 三方账号（网易云/酷狗/QQ/波点/汽水）的歌曲，source 形如 platform-netease */
export function isPlatformAccountSource(source) {
  return typeof source === 'string' && source.startsWith('platform-');
}

let platformSourceHandlers = null;

/**
 * 平台账号模块注册：取播放地址、取歌词。
 * 同时写一份到 globalThis：开发环境 HMR 会让本模块出现两份实例，
 * 策略里 import 到的可能是没有注入过的那一份，靠全局兜底才不会静默丢歌词。
 */
export function setPlatformSourceHandlers(handlers) {
  platformSourceHandlers = handlers || null;
  if (typeof globalThis !== 'undefined') {
    globalThis.__dxhPlatformSourceHandlers = platformSourceHandlers;
  }
}

function platformHandlers() {
  return platformSourceHandlers
    || (typeof globalThis !== 'undefined' ? globalThis.__dxhPlatformSourceHandlers : null)
    || null;
}

export function resolveExternalPluginClient(songOrSource) {
  const source = typeof songOrSource === 'string' ? songOrSource : songOrSource?.source;
  if (!isExternalPluginSource(source)) {
    return null;
  }
  return getPlazaPluginClientBySearchType(source);
}

export async function getExternalPluginMediaSource(song, quality = 'high') {
  if (isPlatformAccountSource(song?.source)) {
    const handlers = platformHandlers();
    if (!handlers?.media) {
      throw new Error('平台音源未就绪');
    }
    return handlers.media(song, quality);
  }
  const client = resolveExternalPluginClient(song);
  if (!client?.getMediaSource) {
    throw new Error(`不支持的插件音源: ${song?.source || 'unknown'}`);
  }
  return client.getMediaSource(song, quality);
}

export async function getExternalPluginLyric(song, options = {}) {
  if (isPlatformAccountSource(song?.source)) {
    const handlers = platformHandlers();
    if (!handlers?.lyric) {
      // 不静默返回 null：策略那边会记一条失败日志，便于发现注册丢失
      throw new Error('平台歌词处理器未就绪');
    }
    return handlers.lyric(song, options);
  }
  const client = resolveExternalPluginClient(song);
  if (!client?.getLyric) {
    throw new Error(`不支持的插件歌词源: ${song?.source || 'unknown'}`);
  }
  return client.getLyric(song, options);
}
